module.exports = __webpack_public_path__ + "static/media/appower.bcb6440c.jpeg";